exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-keyboard-row{padding:2px 0;text-align:center}.vue-keyboard-key{border:none;outline:none;padding:8px 10px;min-width:40px;margin:0 2px;background:#eee;color:#666;cursor:pointer;font-family:inherit;font-size:inherit;border-radius:2px}.vue-keyboard-key:hover{background:#e0e0e0}.vue-keyboard-key:active{background:#777;color:#fff;-webkit-box-shadow:inset 0 1px 4px rgba(#000,.1);box-shadow:inset 0 1px 4px rgba(#000,.1)}.vue-keyboard-key[data-action=space]{min-width:160px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e4cbf998","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-keyboard/src/keyboard.vue
// module id = 141
// module chunks = 0